import * as kcp from "./kcp";
import * as naver from "./naver";
import * as nice from "./nice";

export const plugins = {
    ...kcp,
    ...naver,
    ...nice
}
